import React from "react";
import PropTypes from "prop-types";
import EYTopNavBar from "components/EYTopNavBar";
import { FormattedMessage } from "react-intl";
import config from "config";
import { spinnerService } from "components/Spinner";
import { connect } from "react-redux";
import { selectActionData } from "AuthorizeLink/selectors";
import { getActionData } from "AuthorizeLink/actions";
import { bindActionCreators } from "redux";

const mapStateToProps = state => {
  return {
    actionData: selectActionData(state)
  };
};
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getActionData: actionKey => getActionData(actionKey)
    },
    dispatch
  );

class RFELinkRedirection extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.actionData != this.props.actionData) {
      return true;
    }
  }

  async componentDidMount() {
    const { getActionData, match, actionData } = this.props;
    if (!actionData.action) {
      await getActionData(match.params.actionKey);
    }
  }

  render() {
    const { actionData, match } = this.props;
    if (actionData.action) {
      window.location.replace(
        config.paans.redirectUrl +
          "/" +
          actionData.action +
          "/" +
          match.params.actionKey +
          "/" +
          match.params.email +
          "/" + 
          match.params.sessionId +
          "/" +
          match.params.sessionHash
      );
    }

    return (
      <React.Fragment>
        <div className="container is-fullhd">
          <div className="columns is-centered is-multiline">
            <div className="column is-12" />
            <div className="column is-full">
              <div className="columns here">
                <div className="column">
                  <div className="card">
                    <div className="card-content">
                      <p className="title is-4">
                        <FormattedMessage
                          id={
                            "AuthorizeLink.components.RFELinkRedirection.index.title"
                          }
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RFELinkRedirection);
